import { getFunctions, httpsCallable } from 'firebase/functions';
import { useEffect } from 'react';
import { toast } from 'react-toastify';

const { LoadingButton } = require('@mui/lab');
const {
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  DialogActions,
  Button,
  Typography
} = require('@mui/material');
const { useState } = require('react');

const AddInstagramDialog = ({ open, onClose }) => {
  const [name, setName] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open) {
      setName('');
    }
  }, [open]);

  const handleAddPinterest = async () => {
    setLoading(true);
    try {
      const fn = httpsCallable(getFunctions(), 'instagramRequest');
      const res = await fn({ name, command: 'getOATUHURL' });

      let url = res.data;

      window.open(url, 'popup', 'width=600,height=600');
      onClose();
    } catch (e) {
      console.error(e);
      toast.error('Failed to add Pinterest account');
    }
    setLoading(false);
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Add Instagram</DialogTitle>
      <DialogContent>
        <Typography variant="body2">
          Give a name to your Instagram account to identify it.
        </Typography>
        <TextField
          style={{ marginTop: '10px' }}
          size="medium"
          fullWidth
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <LoadingButton
          disabled={!name}
          loading={loading}
          color="primary"
          onClick={handleAddPinterest}
        >
          Add Instagram
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default AddInstagramDialog;
